import styles from './DetailSkeleton.module.less'

function DetailSkeleton() {
  return (
    <div className={styles['skeleton-wrap']}>
      <div className={styles['tpl-color'] + ' ' + styles['tpl-image-swipper']}></div>
      <div className={styles['tpl-wrapper']}>
        <div style={{display: 'inline-block', width: '90%'}}>
          <div className={styles['tpl-color'] + ' ' + styles['tpl-content-line']} style={{width: '92%'}}></div>
          <div className={styles['tpl-color'] + ' ' + styles['tpl-content-line']} style={{ width: '58%', marginBottom: '40px' }}></div>
          <div className={styles['tpl-color'] + ' ' + styles['tpl-content-line']} style={{ width: '22%'}}></div>
        </div>
        <div className={styles['tpl-color'] + ' ' + styles['tpl-icon']} style={{display: 'inline-block', float: 'right'}}></div>
      </div>

      <div className={styles['tpl-color'] + ' ' + styles['tpl-gap']}></div>

      <div className={styles['tpl-wrapper']}>
        <div className={styles['tpl-color'] + ' ' + styles['tpl-content-line']} style={{width: '58%'}}></div>
        <div className={styles['tpl-color'] + ' ' + styles['tpl-content-line']} style={{width: '30%'}}></div>
        <div className={styles['tpl-color'] + ' ' + styles['tpl-content-line']} style={{width: '60%'}}></div>
        <div className={styles['tpl-color'] + ' ' + styles['tpl-content-line']} style={{width: '30%'}}></div>
      </div>
    </div>
  )
}

export default DetailSkeleton